import React, { useState, useEffect } from 'react';
import { Table, Button, message } from 'antd';
import { EyeOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import ImageType from '../Organism/ImageType';

interface ImageTypeData{
  imageTypeId:string;
  imageTypeName:string;
  isActive:boolean;
  createdBy:string;
  createdDate:string;
  updatedBy:string;
  updatedDate:string;
}

const DisplayImageType: React.FC = () => {
  const [imagetypedata, setData] = useState<ImageTypeData[]>([]);
  const [isAddImageTypeVisible, setIsAddImageTypeVisible] = useState(false);
  const [isEditImageTypeVisible, setIsEditImageTypeVisible] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getImageTypeData();
      }, [isAddImageTypeVisible]);

      const userId = localStorage.getItem("UserId");

      const getImageTypeData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ImageType/GetImageTypes/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setData(response.data);

        } catch (error) {
          console.error("Error fetching image type details", error);
        }
      };

      const handleDeleteImageTypeData = async (imagetypeId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/ImageType/DeleteImageTypes`, 
              null,
            {
              params:{
                type_id: imagetypeId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            message.success('Image Type deleted successfully');
            getImageTypeData();
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const handleEidtImageTypeData = async (imageTypeId: string) => {
        setIsEditImageTypeVisible(imageTypeId);
        setIsAddImageTypeVisible(!isAddImageTypeVisible);
      };

      const columns = [
          {
            title: 'Type Name',
            dataIndex: 'imageTypeName',
            key: 'imageTypeName',
          },
          {
            title: 'Status',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (text: boolean) => (text?"Active":"InActive"),
          },
          {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_: any, record: ImageTypeData) => (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button icon={<DeleteOutlined />} onClick={() => handleDeleteImageTypeData(record.imageTypeId)}>Delete</Button>
                <Button icon={<EditOutlined />} onClick={() => handleEidtImageTypeData(record.imageTypeId)}>Edit</Button>
              </div>
            ),
          },
        ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
              <Button type="primary" onClick={() => setIsAddImageTypeVisible(false)} style={{ marginRight: 8 }}>
                View Image Type
              </Button>
              <Button type="primary" onClick={() => {
                setIsAddImageTypeVisible(true);
                setIsEditImageTypeVisible('');
              }} style={{ marginRight: 8 }}>
                Add Image Type
              </Button>
      </div>
              {isAddImageTypeVisible ? (<ImageType imgtypeid={isEditImageTypeVisible} />) : (<Table dataSource={imagetypedata} columns={columns} rowKey="imageTypeId" />)}
    </div>
  );
};

export default DisplayImageType;